import { useRequest, API_PATH } from '../hooks/useRequest';
/**
 * ============================================
 * C端 - 参与活动/主动塞券接口
 * ============================================
 */
/**
 * Hook - 参与活动（主动塞券）
 * @returns 包含请求函数和状态的对象
 */
export const useJoinActivity = () => {
    return useRequest(API_PATH.JOIN_ACTIVITY);
};
